var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-main"},[_c('van-empty',{staticClass:"custom-image",attrs:{"image":_vm.custom,"description":"您访问的页面不存在"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }